import React from 'react';
import { createRoot } from 'react-dom/client';

import { Provider } from 'react-redux';
import { loadTranslations, setLocale, syncTranslationWithStore } from 'react-redux-i18n';

import store from './config/store';
import { LANG } from './config';
import localization from './components/localization/localization';

import security from './components/common/security/security';
import jwtHelper from './components/common/jwt/jwtHelper';
import delivery from './components/delivery/delivery';

import './config/middlewares';

import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap/dist/css/bootstrap-theme.css';
import 'react-redux-toastr/lib/css/react-redux-toastr.min.css';

import App from './App';

security.configure(store);
jwtHelper.configure(store);
delivery.start();

syncTranslationWithStore(store);
store.dispatch(loadTranslations(localization));
store.dispatch(setLocale(LANG));

const container = document.getElementById('root');
const root = createRoot(container);

root.render(
    <Provider store={store}>
        <App />
    </Provider>
);
